import { isBrowser, isDocker } from './runtime';

/**
 * Get the base URL for API calls
 * In Docker environment: uses route handler proxy on client, direct API URL on server
 * In non-Docker environment: uses the original API URL directly
 */
export function getApiBaseUrl(): string {
  if (isDocker) {
    // In Docker: On the client, go through Next route handler proxy; on the server, use internal API URL
    return isBrowser ? '/api/proxy' : (process.env.API_URL ?? '');
  }

  return process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || '';
}
